import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOReceipt } from 'src/app/shared/models/oo-receipt';

@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.scss']
})
export class ReceiptsComponent implements OnInit {
  error;
  token: string;
  receipt: OOReceipt;

  constructor(public app: AppService, private focuslink: FocuslinkService, private route: ActivatedRoute) { }

  async getReceipt(checkKey) {
    try {
      this.receipt = await this.focuslink.getReceipt(checkKey);
      this.receipt.transactions.sort((a, b) => {
        return (a.created < b.created) ? -1 : ((a.created > b.created) ? 1 : 0);
      });
    } catch (error) {
      this.error = 'Oops! Something went wrong.';
    }
  }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');
    this.getReceipt(this.token);
  }

}
